/*eslint eqeqeq: "off"*/
import React, { useContext } from "react";
import { Stepper, Step, StepLabel, Button, Grid, Box } from "@mui/material";
import { makeStyles } from "@material-ui/core";
import StepperBackArrowDisable, { StepperBackArrowDisableNew } from "../../../assets/images/icon/stepperBackArrowDisable";
import StepperNextArrowDisable, { StepperNextArrowDisableNew } from "../../../assets/images/icon/stepperNextArrowDisable";
import StepperNextArrow, { StepperNextArrowNew, StepperNextArrowNewV2 } from "../../../assets/images/icon/stepperNextArrow";
import StepperBackArrow, { StepperBackArrowNew, StepperBackArrowV2 } from "../../../assets/images/icon/stepperBackArrow";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import palette from "../../../theme/palette";
import useWidth from "../../../utils/useWidth";
import CommonTypo from "../../../components/CommonTypo";

const useStyles = makeStyles((theme) => ({
  stepperWrapperBottom: {
    position: "fixed",
    top: 20,
    right: 20,
    left: 20,
    // background: "red",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    zIndex: 1,
    padding: "20px 48px 20px 80px",
    [theme.breakpoints.down("xl")]: {
      padding: "20px 40px 20px 60px",
    },
    [theme.breakpoints.down("md")]: {
      padding: "20px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "10px",
    },
  },
  TopstepperWrapperBottom: {
    // backgroundColor: palette.common.white,
    // position: "fixed",
    width: "100%",
    top: 0,
    left: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    zIndex: 1,
    padding: "20px 48px 20px 80px",
    [theme.breakpoints.down("xl")]: {
      padding: "20px 40px 20px 60px",
    },
    [theme.breakpoints.down("md")]: {
      padding: "20px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "10px",
    },
  },
}));

interface BottomStepperModal {
  isOutcome: boolean;
  isInfluence: boolean;
  isRefQues: boolean;
  isTracking: boolean;
  curretStep?: number
  handleClickStep?: any
  nextDisabled?: boolean
  prevDisabled?: boolean
  planStep?: number
  isMobile?: boolean
  buttonLoader?: boolean
}

const TopStepper = ({ progress = 0 }) => {
  const classes = useStyles()
  return (
    <Grid
      // xs={9.63}
      item
      className={clsx(classes.stepperWrapperBottom, "stepperWrapperNew")}
    >
      <Box sx={{
        display: "flex",
        gap: "8px",
        width: "100%",
        flexDirection: "column",
        position: "relative"
      }}>
        <Box sx={{
          display: "flex",
          gap: "8px",
          width: "100%",
          flexDirection: "column",
          position: "relative"
        }}>
          <Box sx={{
            width: "100%",
            background: "var(--color-border)",
            height: "8px",
            borderRadius: "8px",
            position: "absolute"
          }}></Box>
          <Box sx={{
            width: progress + "%",
            background: "var(--color-new-main)",
            height: "8px",
            borderRadius: "8px",
            position: "absolute"
          }}></Box>
        </Box>
        <Box sx={{
          display: "flex",
          gap: "8px",
          width: "100%",
          position: "relative",
          marginTop: "8px",
        }}>
          {progress !== 100 && <CommonTypo size={16} color="var(--color-text-secondary)" fontWeight={600} extraSx={{
            position: "absolute",
            left: progress ? (progress) - (1.5) + "%" : "0%",
          }}>{progress}%</CommonTypo>}
          <CommonTypo size={16} color="var(--color-text-secondary)" extraSx={{
            position: "absolute",
            left: 96.5 + "%",
          }}>{100}%</CommonTypo>
        </Box>
      </Box>



    </Grid >
  );
};
export default TopStepper;
